module.exports = __webpack_public_path__ + "static/media/trio v shot 2.4a0bbab4.webp";